Wee.fn.make('products', {
	init: function() {
		var $priv = this.$private;

		$priv.dropdowns();

		if ($('ref:filterForm').length) {
			$priv.populateForm();
		}

		$priv.bind();

		$priv.count = 0;
		$priv.isFiltering = false;

		$priv.catIds = $('ref:filterCat').map(function(el) {
			return $(el).attr('value');
		});

		$.screen.map([
			{
				max: 3,
				callback: function() {
					$priv.manageFilterLocation(false);
					$priv.managePageSizeLocation(false);
					$priv.manageCategoryTitleLocation(false);
				}
			},
			{
				min: 4,
				callback: function() {
					$priv.manageFilterLocation(true);
					$priv.managePageSizeLocation(true);
					$priv.manageCategoryTitleLocation(true);
				}
			}
		]);

		$('ref:siteWrapper').addClass('-no-background');
	}
}, {
	_construct: function() {
		this.hideCategoryIds = [];
		this.noResultClass = '-no-result';
	},
	bind: function() {
		var scope = this,
			$tabContent = $('ref:tabContent'),
			disabledClass = '-is-disabled';

		$.events.on({
			'ref:tabTitle': {
				click: function(e, el) {
					var $el = $(el),
						index = $el.index();

					$el.parent()
						.parent()
						.addClass('-is-expanded');

					$el.enableItem();

					$tabContent.eq(index)
						.enableItem();

					scope.currentIndex = index;
				}
			},
			'ref:closeTab': {
				click: function(e) {
					$('ref:tabTitle').parent()
						.parent()
						.removeClass('-is-expanded');

					$tabContent.eq(scope.currentIndex).disable();

					$('ref:tabTitle').eq(scope.currentIndex)
						.siblings()
						.removeClass(disabledClass);

					e.stopPropagation();
				}
			},
			'ref:filterForm': {
				change: function(e) {
					scope.isFiltering = true;

					scope.fetchProducts({
						setRoot: true
					});

					e.preventDefault();
				}
			},
			'ref:pageSizeSelector': {
				click: function(e, el) {
					var $el = $(el),
						limit = $el.hasClass('-is-disabled') ? $el.text() : false;

					if (limit) {
						$el.enableItem();

						$('ref:limit').val(limit);

						scope.fetchProducts({
							removePagination: true
						});
					}
				}
			},
			'ref:filterBox': {
				click: function(e, el) {
					var $el = $(el);

					if (e.target.nodeName == 'H5') {
						if (! $el.hasClass('-sort')) {
							$el.toggleClass('-is-closed');
						}
					}

					e.stopPropagation();
				}
			},
			'ref:filterReset': {
				click: function(e) {
					$('ref:filterForm').find('input[type="checkbox"]:checked').prop('checked', false);

					$.history.go({
						path: '/' + $.routes.uri().segments.join('/')
					});

					e.preventDefault();
				}
			},
			'ref:priceFilter': {
				change: function(e, el) {
					$('ref:sortMethod').val(el.value);

					scope.fetchProducts();
				}
			},
			'ref:resetPrice': {
				click: function() {
					$('input#price:checked').prop('checked', false);

					scope.fetchProducts();
				}
			}
		});

		$.events.on({
			'ref:openSpecs': {
				click: function(e, el) {
					$('ref:specs').disable();

					$(el).parent()
						.find('ref:specs').enable();

					e.stopPropagation();
				}
			},
			'ref:closeSpecs': {
				click: function(e, el) {
					$(el).parent()
						.find('ref:specs').disable();

					e.stopPropagation();
					e.preventDefault();
				},
				mouseup: function(e) {
					e.stopPropagation();
				}
			},
			'.product__link': {
				click: function(e, el) {
					$.history.go({
						path: el.href.match(/\/products\/(.*)?/g)
					});

					e.preventDefault();
				}
			},
			'.pagination__link': {
				click: function(e, el) {
					var href = el.href.match(/\/P(\d{2,4})/);

					if (href && href.length > 1) {
						scope.fetchProducts({
							page: href[1]
						});
					} else {
						scope.fetchProducts();
					}

					Wee.animate.tween($._body, {
						scrollTop: $('ref:productListContainer').position().top - ($.screen.size() > 3 ? 100 : 10)
					});

					e.preventDefault();
				}
			}
		}, {
			delegate: $.get('promo') ? 'ref:promotionSection' : 'ref:productSection'
		});
	},

	populateForm: function() {
		var scope = this,
			segs = $.routes.uri().segments,
			query = $.routes.uri().query,
			regex = /P(\d{2})/,
			pageNumber = segs.slice(-1)[0].match(regex),
			$categoryId = $.get('categoryId');

		if (Object.keys(query).length > 0) {
			for (var key in query) {
				if (key.substr(0, 8) === 'category') {
					if (typeof query[key] === 'object') {
						$(query[key]).each(function(el) {
							$('ref:filterForm').find('input[value="' + el + '"]')[0].checked = true;
						});
					} else {
						var $input = $('ref:filterForm').find('input[value="' + query[key] + '"][name*="category"]');

						if ($input.length) {
							$input[0].checked = true;
						}
					}
				} else if (key === 'range:productPrice') {
					$('ref:filterForm').find('input[value="' + query[key] + '"]')[0].checked = true;
				} else if (key === 'limit') {
					$('ref:pageSizeSelector').each(function(el) {
						el.innerText === query[key] ? $(el).enable() : $(el).disable();
					});

					$('ref:filterForm').find('input[name="' + key + '"]').val(query[key]);
				} else {
					$('ref:filterForm').find('input[name="' + key + '"]').val(query[key]);
				}
			}
		}

		if ($categoryId && Object.keys(query).length === 0) {
			$('input[name="category[]"][value="' + $categoryId + '"]').attr('checked', true);
		}

		if (segs[2]) {
			var $input = $('input[id="types-' + segs[2] + '"]');

			if ($input.length) {
				$input[0].checked = true;
			}
		}

		if (segs.length > 1 && this.ageRangeCheck(segs[1])) {
			var $ageRange = $('input[id="' + segs[1] + '"]');

			if ($ageRange.length) {
				$ageRange.attr('checked', true);
			}
		}

		$('ref:filterForm').find('input:checked').closest('ref:filterBox').removeClass('-is-closed');

		// If there is a category AND pagination segment in URL, pass it
		if (query.hasOwnProperty('category[]') && pageNumber) {
			this.fetchProducts({
				page: pageNumber[1],
				runHistory: Object.keys(query).length > 1 ? true : false
			});
		} else if (pageNumber) {
			this.fetchProducts({
				page: pageNumber[1],
				runHistory: Object.keys(query).length > 1 ? true : false
			});
		} else {
			this.fetchProducts({
				runHistory: Object.keys(query).length > 1 ? true : false
			});
		}
	},

	fetchProducts: function(options) {
		var scope = this,
			$form = $('ref:filterForm'),
			$productSection = $('ref:productSection'),
			$loadingIcon = $('ref:loadingIcon'),
			replacingClass = '-is-replacing',
			segments = this.getSegmentsWithoutPagination(),
			conf = $.extend({
				removePagination: false,
				page: false,
				runHistory: true,
				setRoot: false
			}, options);

		$.fetch.request({
			url: '/product-search?' + $form.serialize() + '&result_page=product-search' + (conf.page ? '/P' + conf.page : ''),
			send: function() {
				$productSection.addClass(replacingClass);

				$loadingIcon.enable();
			},
			success: function(data) {
				var output = data.replace(/product-search/g, (segments ? segments.join('/') : 'products')),
					query = scope.generateFilterQuery(),
					url = '/';

				if (scope.isFiltering) {
					var regEx = new RegExp('\/' + segments[2] + '[\/]?', 'g');

					// If a specific age range is present, remove it.
					if (segments.some(scope.ageRangeCheck)) {
						$.routes.uri({
							segments: $.routes.uri().segments.slice(0, $.routes.uri().segments.length - 1)
						});
					}

					// If a specific type segment is present, remove it.
					if (segments[2]) {
						output = output.replace(regEx, '/');

						$.routes.uri({
							segments: $.routes.uri().segments.slice(0, $.routes.uri().segments.length - 1)
						});
					}
				}

				$productSection.html(output);

				$loadingIcon.disable();

				$productSection.removeClass(replacingClass);

				if (conf.removePagination || conf.page) {
					url += segments.join('/') + (conf.page ? '/P' + conf.page : '');
				} else {
					url += $.routes.uri().segments.join('/');
				}

				if (conf.setRoot) {
					if (segments.length > 2 && segments[2].indexOf('P') === -1) {
						segments.splice(-1);

						url = '/' + segments.join('/');
					}
				}

				if (conf.runHistory && history && history.replaceState) {
					history.replaceState(
						null,
						'Products',
						url + '?' + query
					);
				}


				$.routes.uri({
					query: Wee.$unserialize(query)
				});

				$.setRef();

				$.setVar();

				Wee.events.trigger('ref:productSection', 'productLoadComplete');

				scope.hideCategories();
			}
		});
	},

	hideCategories: function() {
		var scope = this,
			inputs = $('ref:filterForm').find('input[type="checkbox"]:checked').map(function(el) {
				return $(el).attr('value');
			});

		scope.count++;

		if (inputs.length) {
			(function(internalCount) {
				var cats = inputs.join(',');

				if ($('ref:productsCatGroup').length) {
					cats = cats + '-' + $('ref:productsCatGroup').val();
				}

				$.fetch.request({
					url: '/ajax/filter-categories/' + cats,
					success: function(response) {
						if (internalCount === scope.count) {
							scope.hideCategoryIds = response.split('|');
							scope.applyHideCategories();
						}
					}
				});
			})(scope.count);
		} else {
			scope.hideCategoryIds = [];
			scope.applyHideCategories();
		}
	},

	applyHideCategories: function() {
		var scope = this;

		if (scope.hideCategoryIds.length) {
			// Loop through categories and show/hide based on presence in results
			$('ref:filterCat').each(function(el) {
				var $el = $(el),
					$parent = $el.parent(),
					catId = $el.val();

				if (! $el[0].checked) {

					if (scope.hideCategoryIds.indexOf(catId) !== -1) {
						// Cat has results; be sure it's showing
						if ($parent.hasClass(scope.noResultClass)) {
							$parent.removeClass(scope.noResultClass);
							$el.prop('disabled', false);
						}
					} else {
						// Cat has no results; be sure it's disabled
						if (! $parent.hasClass(scope.noResultClass)) {
							$parent.addClass(scope.noResultClass);
							$el.prop('disabled', true);
						}
					}
				}
			});

			scope.hideCategoryIds = [];
		} else {
			$('ref:filterCat').prop('disabled', false).parent().removeClass(scope.noResultClass);
		}
	},

	diffArray: function(firstArray, secondArray) {
		var seen = [],
			diff = [];

		for (var i = 0; i < secondArray.length; i++) {
			seen[secondArray[i]] = true;
		}

		for (i = 0; i < firstArray.length; i++) {
			! seen[firstArray[i]] && diff.push(firstArray[i]);
		}

		return diff;
	},

	getSegmentsWithoutPagination: function() {
		var segments = $.routes.uri().segments.filter(function(segment) {
			return segment.substring(0, 1) !== 'P';
		});

		return segments;
	},

	generateFilterQuery: function() {
		var queryOptions = ['ACT', 'site_id', 'csrf_token'];
		var query = $('ref:filterForm').serialize().split('&').filter(function(el) {
			var pair = el.split('=');

			if (queryOptions.indexOf(pair[0]) != -1) {
				return false;
			} else {
				return true;
			}
		});

		return query.join('&');
	},

	dropdowns: function() {
		var scope = this,
			$productLines = $('ref:productLines'),
			query = $.routes.uri().query;

		$productLines.find('option').each(function(el) {
			if (el.value === $.routes.uri().segments[1]) {
				$(el).prop('selected', true);
			}
		});

		if (! $.routes.uri().segments[1]) {
			$productLines.find('option[value=all-products]').prop('selected', true);
		}

		Wee.dropdown.init({
			selector: 'ref:productLines',
			appPrefix: 'first',
			rootModifier: 'filter-options__dropdown',
			isSelected: true,
			itemClick: function(obj) {
				var segments = $.routes.uri().segments,
					path = '/';

				path += obj.value === 'all-products' ? segments[0] : segments[0] + '/' + obj.value;

				// $.history.go({
				// 	path: path
				// });

				window.location = path;
			}
		});

		if (query.hasOwnProperty('orderby_sort')) {
			var queryValue = query.orderby_sort, // jscs:ignore
				$options = $('ref:sortSelect').find('option');

			switch (queryValue) {
				case 'productPrice|desc':
					$('ref:priceFilter').filter('[value="productPrice|desc"]').attr('checked', true);

					$options[0].selected = true;
					break;
				case 'productPrice|asc':
					$('ref:priceFilter').filter('[value="productPrice|asc"]').attr('checked', true);

					$options[1].selected = true;
					break;
			}
		}

		Wee.dropdown.init({
			selector: 'ref:sortSelect',
			appPrefix: 'second',
			isSelected: true,
			rootModifier: 'desktop-sort__dropdown',
			itemClick: function(obj) {
				$('ref:sortMethod').val(obj.value);

				scope.fetchProducts();
			}
		});
	},

	/**
	 * Moves the filter options to their proper
	 * location depending on screen size.
	 *
	 * @private
	 */
	manageFilterLocation: function(desktop) {
		var $filterOptions = $('ref:desktopFilterOptions');

		if (desktop) {
			$('ref:filterTabs').before($filterOptions);

			$filterOptions.enable().addClass('-desktop');
		} else {
			$('ref:tabList').after($filterOptions);

			$filterOptions.disable().removeClass('-desktop');
		}
	},

	/**
	 * Moves the page-size element depending on screen size.
	 *
	 * @private
	 */
	managePageSizeLocation: function(desktop) {
		var $pageSize = $('ref:pageSize');

		if (desktop) {
			$('ref:productList').prepend($pageSize);
		} else {
			$('ref:filterForm').after($pageSize);
		}
	},

	/**
	 * Moves the category title to their proper
	 * location depending on screen size.
	 *
	 * @private
	 */
	manageCategoryTitleLocation: function(desktop) {
		var $categoryTitle = $('ref:categoryTitle');

		if (desktop) {
			$('ref:productList').prepend($categoryTitle);
		} else {
			$('ref:productRow').before($categoryTitle);
		}
	},

	ageRangeCheck: function(el) {
		var ages = [
			'6-to-23-months',
			'2-to-5-years',
			'5-to-12-years',
			'13-years'
		];

		return ages.indexOf(el) > -1;
	}
});
